import { ErrorResponse } from '../../Interface/ErrorResponse';
import { filterFinishedLoading, filterSubmitted } from '../../Store/Filter/action';
import { getPropertiesPerProperty } from '../../Service/ProductPropertiesAPIService';
import { getAcceptationGuideData } from '../../Service/Interest/InterestService';
import { INITIAL_TABLE_STATE, InterestTableState } from '../../Interface/Hook/Interest/InterestTableState';
import { InterestTableDTO } from '../../Interface/Hook/Interest/InterestTableDTO';
import { PROPERTIES_PER_PROPERTY_FILTER } from '../../Constants/Interest/Filter';
import reduceTablePropertiesPerPropertyData from '../../Reducer/ReduceTablePropertiesPerPropertyData';
import { tokenExpired } from '../../Store/Auth/action';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useGetLabels from '../Interest/UseGetLabels';
import useFilterIsActual from '../Interest/UseFilterIsActual';

const useGetPropertiesPerProperty = (properties: string[]): InterestTableDTO => {
    const dispatch = useDispatch();
    const filterIsActual = useFilterIsActual(PROPERTIES_PER_PROPERTY_FILTER);
    const { allLabels } = useGetLabels(false);
    const [{ error, data, headers, loading }, setState] = useState<InterestTableState>(INITIAL_TABLE_STATE);

    const fetchData = useCallback(() => {
        if (!filterIsActual) dispatch(filterSubmitted());
        if (filterIsActual)
            if (properties.length === 0) {
                setState({ ...INITIAL_TABLE_STATE, error: true, loading: false });
                dispatch(filterFinishedLoading());
            } else if (properties.length > 0) {
                Promise.all([
                    getPropertiesPerProperty(properties),
                    getAcceptationGuideData(),
                ]).then(
                    ([result, acceptationGuideData]) => {
                        setState({
                            error: false,
                            ...reduceTablePropertiesPerPropertyData(result, allLabels, acceptationGuideData),
                            loading: false,
                        });
                        dispatch(filterFinishedLoading());
                    },
                    (errorResult: ErrorResponse) => {
                        errorResult.code === 403
                            ? dispatch(tokenExpired())
                            : setState({ error: true, data, headers, loading: false });
                        dispatch(filterFinishedLoading());
                    },
                );
            }
    }, [allLabels, dispatch, filterIsActual, properties, data, headers]);

    useEffect(() => fetchData(), [properties]);

    return { data, error, headers, loading };
};

export default useGetPropertiesPerProperty;
